import { type FC, Fragment, lazy, Suspense } from 'react'

import type { FireworkBrandingProps } from './FireworkBranding.types'

const Component = lazy(() => import('./FireworkBranding'))

/**
 * Lazy-loadable one-to-one branding component
 */
export const FireworkBranding: FC<FireworkBrandingProps> = (props) => (
  <Suspense fallback={<Fragment />}>
    <Component {...props} />
  </Suspense>
)
